import React from 'react';
import { planMemberIcon } from '../pages/merchant/pricing/pricingUtils';

type PlanMemberMarkProps = {
  name?: string | null;
  grade?: number | null;
  className?: string;
};

/** 按当前用户套餐名称或等级显示基础、专业、豪华徽章。 */
export function PlanMemberMark({ name, grade, className = 'plan-member-mark' }: PlanMemberMarkProps) {
  const src = planMemberIcon({
    displayName: name?.trim() || undefined,
    grade: typeof grade === 'number' ? grade : undefined
  });
  if (!src) return null;
  return <img src={src} alt='' className={className} />;
}
